module.exports = __webpack_public_path__ + "d1e112a3d7a80e2544824acf42d22dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iyv-social-share.jpg
// module id = 1957
// module chunks = 0